import api from "./axios";
import { apiPaths } from "./paths";
import type { PaginatedResponse, MetricRequest, StatsResponse } from "@/types";

export interface RequestParams {
  projectId?: string;
  metricId?: string;
  startDate?: string;
  endDate?: string;
  page?: number;
  limit?: number;
}

export type StatsParams = Omit<RequestParams, "page" | "limit">;

export const getRequests = (params: RequestParams) =>
  api
    .get<PaginatedResponse<MetricRequest>>(apiPaths.requests.list, { params })
    .then((r) => r.data);

export const getStats = (params: StatsParams) =>
  api
    .get<StatsResponse>(apiPaths.requests.stats, { params })
    .then((r) => r.data);
